import React, { useEffect, useState } from 'react';
import { Modal, Form, Button, Input, message, Divider, Transfer } from 'antd';
import useSWRImmutable from 'swr/immutable';
import {
    GENERIC_ERROR_MESSAGE,
    validateMessages,
} from '../../constants/feedback';
import {
    PERFIL_BUSQUEDAS_ENDPOINT,
    createPerfilBusqueda,
    getPerfilBusquedaById,
    updatePerfilBusqueda,
} from '../../services/api/perfil-busqueda';
import {
    CONJUNTO_BUSQUEDAS_KVP_ENDPOINT,
    getAllConjuntoBusquedasAsKvpList,
} from '../../services/api/conjunto-busqueda';

const itemLayout = {
    labelCol: { span: 24 },
};

const PerfilBusquedaItem = (props) => {
    const { isModalOpen, idPerfilBusqueda, onSave, onCancel } = props;
    const [conjuntoSourceData, setConjuntoSourceData] = useState([]);
    const [conjuntoTargetKeys, setConjuntoTargetKeys] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();

    const { data: conjuntoBusquedas } = useSWRImmutable(
        CONJUNTO_BUSQUEDAS_KVP_ENDPOINT,
        () => getAllConjuntoBusquedasAsKvpList(),
        { revalidateOnMount: true }
    );

    const { data: perfilBusqueda, mutate } = useSWRImmutable(
        idPerfilBusqueda > 0
            ? [PERFIL_BUSQUEDAS_ENDPOINT, idPerfilBusqueda]
            : null,
        ([_, idPerfilBusqueda]) => getPerfilBusquedaById(idPerfilBusqueda),
        { revalidateOnMount: true }
    );

    useEffect(() => {
        if (idPerfilBusqueda > 0 && perfilBusqueda?.data) {
            let fields = Object.keys(perfilBusqueda.data).map((key) => ({
                name: key,
                value: perfilBusqueda.data[key],
            }));

            form.setFields(fields);
            setConjuntoTargetKeys(perfilBusqueda.data.conjuntos);
        }
    }, [idPerfilBusqueda, perfilBusqueda, form]);

    useEffect(() => {
        const tempSourceData = [];

        if (conjuntoBusquedas?.data) {
            for (const conjunto of conjuntoBusquedas?.data) {
                const data = {
                    key: conjunto.idConjunto,
                    title: conjunto.descripcion,
                };

                tempSourceData.push(data);
            }

            setConjuntoSourceData(tempSourceData);
        }
    }, [conjuntoBusquedas]);

    const filterOption = (inputValue, option) =>
        option.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;

    const handleTransferChange = (newTargetKeys) => {
        setConjuntoTargetKeys(newTargetKeys);
    };

    const handleCancelClick = () => {
        form.resetFields();
        onCancel();
    };

    const handleFinishClick = async (values) => {
        try {
            setIsLoading(true);

            const params = {
                ...values,
                idPerfilBusqueda,
            };

            if (idPerfilBusqueda > 0) {
                await updatePerfilBusqueda(params);
                mutate();
            } else {
                await createPerfilBusqueda(params);
            }

            form.resetFields();
            onSave();
        } catch (error) {
            message.error(GENERIC_ERROR_MESSAGE);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            open={isModalOpen}
            title='Perfil de búsqueda'
            onCancel={handleCancelClick}
            destroyOnClose={true}
            footer={[
                <Button key='back' onClick={handleCancelClick}>
                    Cancelar
                </Button>,
                <Button
                    type='primary'
                    onClick={form.submit}
                    loading={isLoading}
                >
                    Guardar
                </Button>,
            ]}
            style={{ top: 20 }}
        >
            <Form
                form={form}
                onFinish={handleFinishClick}
                validateMessages={validateMessages}
                autoComplete='off'
            >
                <Divider className='mb-2'></Divider>

                <div className='row pl-2 pr-2'>
                    <div className='col-lg-12'>
                        <Form.Item
                            name='descripcion'
                            label='Descripción'
                            {...itemLayout}
                            rules={[
                                {
                                    required: true,
                                    whitespace: true,
                                },
                            ]}
                        >
                            <Input maxLength={50} allowClear />
                        </Form.Item>
                    </div>

                    <div className='col-lg-12'>
                        <Form.Item
                            name='conjuntos'
                            label='Conjuntos de búsqueda'
                            {...itemLayout}
                        >
                            <Transfer
                                dataSource={conjuntoSourceData}
                                listStyle={{
                                    width: 300,
                                    height: 300,
                                }}
                                showSearch
                                filterOption={filterOption}
                                targetKeys={conjuntoTargetKeys}
                                onChange={handleTransferChange}
                                render={(item) => item.title}
                            />
                        </Form.Item>
                    </div>
                </div>
            </Form>
        </Modal>
    );
};

export default PerfilBusquedaItem;
